import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  GRID_AREA_BADGE,
  GRID_AREA_TITLE,
} from 'applications/GSP/pages/ParentHelper/components/Chat/components/Header/constants';
import { useParentHelperContext } from 'applications/GSP/pages/ParentHelper/providers/ParentHelperProvider/hooks';

import { Avatar } from './components/Avatar';
import { Badge } from './components/Badge';

import type { FC } from 'react';

export const Bot: FC = () => {
  const { t } = useTranslation();
  const { isError } = useParentHelperContext();

  return (
    <>
      <Badge
        isOnline={!isError}
        variant="dot"
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{ gridArea: GRID_AREA_BADGE }}
      >
        <Avatar>
          <SupportAgentIcon />
        </Avatar>
      </Badge>
      <Typography variant="body1" sx={{ gridArea: GRID_AREA_TITLE }}>
        {t('GSP.pages.parentHelper.chat.header.title')}
      </Typography>
    </>
  );
};
